<template>
  <div class="signin" @keyup.enter="login">
    <div class="signin-logo"><span class="sys-logo"></span></div>
    <div class="signin-name">{{systemName}}</div>
    <div class='signin-inpput-box'>
      <div class="e-input-group e-float-icon-left">
        <span class="icon hero-icon hero-icon-username"></span>
        <div class="e-input-in-wrap">
          <input class="e-input" type="text" :placeholder="$t('Login.username')" v-model="username" />
        </div>
      </div>
      <div class="e-input-group e-float-icon-left">
        <span class="icon hero-icon hero-icon-unlock"></span>
        <div class="e-input-in-wrap">
          <input class="e-input" type="password" :placeholder="$t('Login.password')" v-model="password" />
        </div>
      </div>
      <div class="e-input-group e-float-icon-left">
        <span class="icon hero-icon hero-icon-captcha"></span>
        <div class="e-input-in-wrap">
          <input class="e-input" type="text" :placeholder="$t('Login.kaptcha')" v-model="kaptcha" style="width: 103px;">
          <img :src="kaptcha_url" @error="loadErrorFun" @click="refreshKaptcha" width="75" height="30" class="kaptcha"/>
        </div>
      </div>
    </div>
    <ejs-button :isPrimary="true" class="e-control e-btn e-lib e-primary btn-block"
                @click.native="login">{{$t('Login.login')}}</ejs-button>
    <a href="#" class="up-href lic-href" @click.stop.prevent="showLicenseUpload">{{$t('Login.uploadLicense')}}</a>
    <a href="#" class="up-href eula-href" @click.stop.prevent="showCopyright">{{$t('Login.copyright')}}</a>
    <CustomDialog ref="pwdDialog"
        v-bind:element="pwdDialog.element"
        v-bind:styles="pwdDialog.styles">
      <template slot="dialog-content">
        <ModifyPasswd ref="modiyPwd"></ModifyPasswd>
      </template>
    </CustomDialog>
    <CustomDialog ref="upLicDialog"
        v-bind:element="upLicDialog.element"
        v-bind:styles="upLicDialog.styles">
      <template slot="dialog-content">
        <ejs-uploader ref="upLicense" name="upLicense" :asyncSettings="uploadSettings.asyncSettings"
          :multiple="uploadSettings.multiple" :autoUpload="uploadSettings.autoUpload" :allowedExtensions = "uploadSettings.extensions"  :success="uploadResult"></ejs-uploader>
      </template>
    </CustomDialog>
    <CustomDialog ref="forceLoginDialog"
                  v-bind:element="forceLoginDialog.element"
                  v-bind:styles="forceLoginDialog.styles">
      <template slot="dialog-content">
        <div>{{forceLoginMsg}}</div>
      </template>
    </CustomDialog>
    <CustomDialog ref="copyrightDialog"
                  v-bind:element="copyrightDialog.element"
                  v-bind:styles="copyrightDialog.styles">
      <template slot="dialog-content">
        <div>
          <div>{{$t('Login.copyright')}}</div>
          <div>{{$t('Login.copyrightInfo.line1')}}</div>
          <div>{{$t('Login.copyrightInfo.line2')}}</div>
          <div>{{$t('Login.copyrightInfo.line3')}}</div>
          <div>{{$t('Login.copyrightInfo.line4')}}</div>
          <div>{{$t('Login.copyrightInfo.line5')}}</div>
          <div>{{$t('Login.copyrightInfo.line6')}}</div>
          <div>{{$t('Login.copyrightInfo.line7')}}</div>
          <div>{{$t('Login.copyrightInfo.line8')}}</div>
          <div>{{$t('Login.copyrightInfo.line9')}}</div>
          <div>{{$t('Login.copyrightInfo.line10')}}</div>
          <div>{{$t('Login.copyrightInfo.line11')}}</div>
          <div>{{$t('Login.copyrightInfo.line12')}}</div>
          <div>{{$t('Login.copyrightInfo.line13')}}</div>
          <div>{{$t('Login.copyrightInfo.line14')}}</div>
          <div>{{$t('Login.copyrightInfo.line15')}}</div>
          <div>{{$t('Login.copyrightInfo.line16')}}</div>
          <div>{{$t('Login.copyrightInfo.line17')}}</div>
          <div>{{$t('Login.copyrightInfo.line18')}}</div>
          <div>{{$t('Login.copyrightInfo.line19')}}</div>
          <div>{{$t('Login.copyrightInfo.line20')}}</div>
          <div>{{$t('Login.copyrightInfo.line21')}}</div>
          <div>{{$t('Login.copyrightInfo.line22')}}</div>
          <div>{{$t('Login.copyrightInfo.line23')}}</div>
          <div>{{$t('Login.copyrightInfo.line24')}}</div>
          <div>{{$t('Login.copyrightInfo.line25')}}</div>
          <div>{{$t('Login.copyrightInfo.line26')}}</div>
        </div>
      </template>
    </CustomDialog>
    <ejs-toast ref='remindToast' id='remindToast' :position='remindToast.position' :newestOnTop="onTop" showCloseButton=true
      :animation="remindToast.showAnimation"></ejs-toast>
  </div>
</template>

<script>
import CustomDialog from '../common/CustomDialog';
import ModifyPasswd from '../security/accountManager/modifyPasswd'

export default {
  name: 'LoginForm',
  components: {
    CustomDialog,
    ModifyPasswd
  },
  data() {
    return {
      onTop: false,
      username: '',
      password: '',
      kaptcha: '',
      kaptcha_url: '/lte/security/captcha',
      systemName: '',
      pwdDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'pwdDialog',
          buttonGroup: [
            {
              click: this.closeModify,
              buttonModel: { content: `${this.$t('System.cancel')}` }
            },
            {
              click: this.modifyPwd,
              buttonModel: { cssClass: 'e-primary', content: `${this.$t('Common.ok')}` }
            }
          ],
          title: `${this.$t('Login.updPasswdTitle')}`
        },
        styles: {
          width: '600px',
          height: '400px',
          model: true,
          visible: false
        }
      },
      upLicDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'upLicDialog',
          buttonGroup: [
            {
              click: this.closeUpload,
              buttonModel: { content: `${this.$t('System.close')}` }
            }
          ],
          title: `${this.$t('Login.uploadLicense')}`
        },
        styles: {
          width: '600px',
          height: '400px',
          model: true,
          visible: false
        }
      },
      forceLoginDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'forceLoginDialog',
          buttonGroup: [
            {
              click: this.closeForce,
              buttonModel: { content: `${this.$t('System.cancel')}` }
            },
            {
              click: this.forceLogin,
              buttonModel: { cssClass: 'e-primary', content: `${this.$t('Common.ok')}` }
            }
          ],
          title: `${this.$t('Login.forceLoginTitle')}`
        },
        styles: {
          width: '300px',
          height: '200px',
          model: true,
          visible: false
        }
      },
      copyrightDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'copyrightDialog',
          title: `${this.$t('Login.copyright')}`
        },
        styles: {
          width: '600px',
          height: '400px',
          model: true,
          visible: false
        }
      },
      uploadSettings: {
        asyncSettings: {
          saveUrl: '/lte/security/uploadNMSLicense',
          removeUrl: ''
        },
        multiple: false,
        autoUpload: false,
        extensions: '.enc',
      },
      remindToast: {
        position: {
          X: 'Right', Y: 'Bottom'
        },
        showAnimation: { show : { effect: 'SlideBottomIn' }, hide : { effect: 'SlideBottomOut'} }
      },
      forceLoginMsg: '',
      kickout: false,
    };
  },
  mounted () {
    this.initSysInfo();
    this.$loading.hideLoadding()
  },
  methods: {
    initSysInfo() {
      const That = this;
      this.$axios.get('/lte/security/findSystemName', {}).then((res) => {
        if(res.status==200) {
          That.systemName = res.data;
        }
      });
      let userUrl = '/lte/ems/strategy/findAccountStrategy';
      let pwdUrl = '/lte/ems/strategy/findPwdStrategy';
      this.axios.get(userUrl, {}).then(response => {
        const result = response.data;
        sessionStorage.setItem('userStrategy', JSON.stringify(result.items));
      });
      this.axios.get(pwdUrl, {}).then(response => {
        const result = response.data;
        sessionStorage.setItem('pwdStrategy', JSON.stringify(result.items));
      });
    },
    login() {
      if(this.username==''){
        this.$refs.remindToast.show({
          title: `${this.$t('Common.warning')}`,
          content: `${this.$t('Security.placeholder.username')}`,
          cssClass: 'e-toast-warning',
          icon: 'e-warning toast-icons'
        });
        return false;
      }
      if(this.password==''){
        this.$refs.remindToast.show({
          title: `${this.$t('Common.warning')}`,
          content: `${this.$t('Security.placeholder.password')}`,
          cssClass: 'e-toast-warning',
          icon: 'e-warning toast-icons'
        });
        return false;
      }
      let That = this;
      let userStrategy = JSON.parse(sessionStorage.getItem('userStrategy'));
      this.$axios.post('/lte/security/login', {
        accountName: this.username,
        accountPwd: this.password,
        verifyCode: this.kaptcha,
        kickout: this.kickout
      }).then((res) => {
        if (res.data.status === 0) {
          localStorage.setItem('mldn-session-id', 'temp')
          sessionStorage.setItem('principal', JSON.stringify(res.data.principal));
          sessionStorage.setItem('version', JSON.stringify(res.data.version));
          That.$router.replace({
            path: '/index'
          });
        } else if (res.data.status === 4) {
          That.$refs.remindToast.show({
            title: `${this.$t('Common.information')}`,
            content: `${this.$t('Login.firstLogin')}`,
            cssClass: 'e-toast-info',
            icon: 'e-info toast-icons'
          });
          That.$refs.pwdDialog.show();
        } else if (res.data.status === 14) {
          That.forceLoginMsg = res.data.msg;
          That.$refs.forceLoginDialog.show();
        } else if (res.data.status === 16) {
          // 提示密码已过期
          That.$refs.remindToast.show({
            title: `${this.$t('Common.warning')}`,
            content: `${this.$t('Login.pwdExpired')}`,
            cssClass: 'e-toast-warning',
            icon: 'e-warning toast-icons'
          });
          That.$refs.pwdDialog.show();
        } else if (res.data.status === 2) {
          let msg = res.data.msg;
          msg = msg.replace('#', userStrategy['acc.failCount'])
          msg = msg.replace('&', userStrategy['acc.lockTime'])
          That.$refs.remindToast.show({
            title: `${this.$t('Common.warning')}`,
            content: msg,
            cssClass: 'e-toast-warning',
            icon: 'e-warning toast-icons'
          });
          That.refreshKaptcha();
        } else {
          That.$refs.remindToast.show({
            title: `${this.$t('Common.warning')}`,
            content: res.data.msg,
            cssClass: 'e-toast-warning',
            icon: 'e-warning toast-icons'
          });
          That.refreshKaptcha();
        }
      });
    },
    forceLogin() {
      this.kickout = true;
      this.login();
      this.$refs.forceLoginDialog.clear();
      this.$refs.forceLoginDialog.close();
    },
    refreshKaptcha() {
      this.kaptcha_url = '/lte/security/captcha?t=' + new Date().getTime();
    },
    modifyPwd() {
      this.$refs.modiyPwd.initStrategy();
      const modify_url = '/lte/security/unLoginModifyPwd';
      let validate = this.$refs.modiyPwd.validate();
      if(validate) {
        const password = this.$refs.modiyPwd.getModifyParams();
        const That = this;
        this.$axios.post(modify_url, {
          username: this.username,
          password: password
        }).then(response => {
          if (response.data) {
            That.password = password;
            That.closeModify();
            That.login();
          } else {
            That.$layer.alert({ msg: `${this.$t('Login.failure')}` })
          }
        })
      }
    },
    uploadResult(args) {
      let event = args.e;
      let info = event.target.responseText;
      document.getElementsByClassName("e-file-status")[0].innerHTML = info;
      console.log(document.getElementsByClassName("e-file-status e-upload-success")[0].innerHTML);
    },
    loadErrorFun() {
      this.$refs.remindToast.show({
        title: `${this.$t('Common.error')}`,
        content: `${this.$t('Login.kaptchaError')}`,
        cssClass: 'e-toast-danger',
        icon: 'e-error toast-icons'
      });
    },
    showLicenseUpload() {
      this.$refs.upLicDialog.show();
    },
    showCopyright() {
      this.$refs.copyrightDialog.show();
    },
    closeModify() {
      this.$refs.pwdDialog.close();
    },
    closeUpload() {
      this.$refs.upLicDialog.close();
    },
    closeForce() {
      this.$refs.forceLoginDialog.close();
    }
  }
};
</script>

<style scoped>
.kaptcha {
  width: 75px;
  height: 30px;
  position: relative;
  top: -8px;
  left: 0;
}
.up-href {
  display: block;
  text-decoration: none;
  font-size: 12px;
  color: #b6c0ca;
  margin-top: 8px;
  position: relative;
	top: -45px;
	left: 0;
}
.up-href:hover {
  color: #299ff7;
}
.lic-href {
  margin-right: 20px;
  float: left;
}
.eula-href {
  float: left;
}
</style>
